import { useEffect, useMemo } from "react";
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';
import { Button } from 'antd';
import { IMAGE_TYPE, BATCH_IMAGES_TYPE } from '@utils/CONST'
import API from '@api/api'
import Utils from '@utils/utils'


const PicModalFooter = (props) => {
    const { item } = props

    const IsEiEdit = useMemo(() => {
        return item.imageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION ||
            item.imageType == IMAGE_TYPE.REMOVE_INPAINT ||
            item.imageType == IMAGE_TYPE.AI_BEAUTY ||
            item.imageType == IMAGE_TYPE.AI_SMART_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_RESIZE ||
            item.imageType == IMAGE_TYPE.HAND_FIX
    }, [item])


    const downloadClick = async (taskId, imageId) => {
        const res = await API.batchCommonDownload({ taskId: taskId.split('_')[0], imageId })
        if (res?.code != 0) throw new Error(res?.message)
        Utils.downUrl(res.data)
    }

    return (
        <div className={styles.PicModalFooter}>
            {
                (IsEiEdit || item?.orgData) ? <span></span> : <div className={styles.footer}>
                    {
                        !props.isSelectPage && <>
                            {
                                (item?.projectType != BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH &&
                                    item?.projectType != BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) &&
                                <span
                                    className={styles.footer_text}
                                    onClick={() => props.reEditClick(item?.projectId, item?.skuId, item?.taskId)}>
                                    <Iconfont type="icon-rebuildOutlined" className={styles.Icon} />重新编辑
                                </span>
                            }
                            {
                                (item?.projectType != BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH &&
                                    item?.projectType != BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) &&
                                <span
                                    className={styles.footer_text}
                                    onClick={() => { props.regenerateByTaskId(item?.taskId); props.onCancel() }}>
                                    <Iconfont type="icon-generateOutlined" className={styles.Icon} />再次生成
                                </span>
                            }
                        </>
                    }
                </div>
            }
            <Button className={styles.downloadBtn} style={{ margin: '0 12px' }} onClick={() => downloadClick(item?.taskId, item?.results?.[0]?.id)}>下载图片</Button>
            {
                (!props.isSelectPage && item?.projectType != BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) && <>
                    <Button className={styles.downloadBtn} type={item?.results?.[0]?.picked ? 'primary' : 'default'} onClick={(e) => props.handleChoose(e, item)}>
                        <Iconfont className={styles.Icon} type="icon-imgOutlined" />
                        {item?.results?.[0]?.picked ? '已选中' : '选这张'}</Button>
                </>
            }
        </div>
    )
}

export default PicModalFooter